import * as api from '@/lti/api'
import { storeAllEntities } from '@/lti/store/helpers'

export default {
  state: {
    rps: {},
  },

  actions: {},

  getters: {},
}
